import React from "react";
import { Link } from "react-router-dom";
import "./motorcycle-item.scss";

export default function MotorcycleCard({ moto }) {
  return (
    <div className="moto-card">
      <div className="moto-card__image">
        <img src={moto.main_image} alt={moto.title} />
      </div>

      <div className="moto-card__content">
        <h3 className="moto-card__title">{moto.title}</h3>

        <p className="moto-card__price">
          Cena: <strong>{moto.price.toLocaleString()} PLN</strong>
        </p>

        <div className="moto-card__specs">
          <p><span>📌 Przebieg:</span> {moto.mileage} km</p>
          <p><span>📅 Rok produkcji:</span> {moto.production_year} r.</p>
          <p><span>⚙️ Pojemność:</span> {moto.engine_capacity} cc</p>
          <p><span>🅰️ Prawo jazdy:</span> {moto.license_category}</p>
        </div>

        <Link to={`/motocykle/${moto.id}`} className="moto-card__button">
          ZOBACZ WIĘCEJ
        </Link>
      </div>
    </div>
  );
}
